<template>
  <div class="content">
    <div class="infos">
      <div class="info" v-for="(item,i) in list" :key="i" @click="detail(item)">
        <el-image class="img" :src="item.picture_link_list[0]" fit="cover"></el-image>
        <p>{{item.product_name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { adminProductInfo } from "@/request/api";
export default {
  name: "HomeView",
  data() {
    return {
      page: 1,
      size: 50,
      list: [],
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
    };
  },
  created() {
    this.getList();
  },
  methods: {
    detail(e){
      this.$router.push({ path: '/details', query: { info: e } })
    },
    getList() {
      adminProductInfo({
        page: this.page,
        page_size: this.size
      }).then(res => {
        console.log(res);
        this.list = res.results[0].results;
      });
    }
  }
};
</script>

<style scoped>
.infos {
  width: 92%;
  display: flex;
  /* justify-content: center; */
  flex-wrap: wrap; /* 使得内容自动换行 */
  margin-top: 40px;
  margin: 40px 4% 0;
  /* background-color: pink; */
}

.info {
  width: 25%; /* 每个 .info 元素占 23% 的宽度，四个元素可以放在一行 */
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 70px;
}

.img {
  width: 400px;
  height: 400px;
}

p {
  font-size: 20px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Goods.vue